import {faHeartPulse} from "@fortawesome/free-solid-svg-icons";

export default faHeartPulse;
